import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: theme => css`
    #roomContainer {
      border-radius: ${theme.border.radius.lg} !important;

      height: 500px;

      @media (min-width: 500px) {
        height: calc(100vh - 420px);
      }
    }
  `,

  meetContainer: css`
    width: 100%;
    height: 100%;
  `,

  fullScreenMeet: css`
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10;

    #roomContainer {
      height: 100%;

      @media (min-width: 500px) {
        height: 100%;
      }
    }
  `,

  inviteGuestButton: theme => css`
    margin-bottom: ${theme.spacing.sm};
  `,

  meetingInformations: theme => css`
    display: flex;
    gap: ${theme.spacing.xs};
    flex-wrap: wrap;
    margin: ${theme.spacing.xxs} 0 ${theme.spacing.xs};

    @media (max-width: ${theme.grid.breakpoint.sm}) {
      gap: ${theme.spacing.xxs};
    }

    li {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      color: ${theme.colors.neutral[500]};

      &::before {
        content: '';
        display: inline-flex;
        width: ${theme.spacing.xxs};
        height: ${theme.spacing.xxs};
        border-radius: ${theme.border.radius.full};
        background-color: ${theme.colors.brand.primary[300]};
      }

      span {
        display: inline-flex;
        color: ${theme.colors.neutral[300]};
      }
    }
  `,
})

export { useStyles }
